<div class="container-fluid">
	<header>
		<div clas="row">
			<div class="page-title"><span>{{getCaption()}}</span></div>
			<div class="logo"><div class="logo-container {{getLogo()}}"></div></div>
		</div>
	</header>
</div>
